
import * as actionTypes from './actionTypes';

export const initDnsStart = () => {
  return {
    type: actionTypes.INIT_DNS_START
  };
};
export const resetDnsState = () => {
  return {
    type: actionTypes.RESET_DNS_STATE,
    
  };
}
export const refreshDns = () => {
  return window.location.reload();
};
export const setDns = (realDns) => {
  return {
    type: actionTypes.SET_DNS,
    realDns:realDns
  };
};

export const fetchDnsFailed = () => {
  return {
    type: actionTypes.FETCH_DNS_FAILED
  };
};

export const initDns = () => {
  return {
    type: actionTypes.INIT_DNS
  };
};

export const changeDns = (primaryDns, secondaryDns, enabled) => {
  return {
    type: actionTypes.CHANGE_DNS,
    primaryDns: primaryDns,
    secondaryDns: secondaryDns,
    enabled: enabled
  };
}

export const changeDnsFailed = (errorStatus) => {
  return {
    type: actionTypes.CHANGE_DNS_FAILED,
    errorStatus: errorStatus
  }
}
export const changeDnsSuccess = () => {
  return {
    type: actionTypes.CHANGE_DNS_SUCCESS
  }
}
export const resetDnsErrorSuccess = () => {

  return {
    type: actionTypes.RESET_DNS_ERROR_SUCCESS
  }
}